<app-access-manager [namespace]="pageAccessBit">


  <style>
    .payment-methods-grid {
      display: grid;
      grid-template-columns: 120px 100px 40px auto;
      row-gap: 12px;
      column-gap: 24px;
    }

    .payment-method-row {
      display: contents;
    }

    .card-type {
      color: var(--green-800, #1a7a4c);
      font-size: 14px;
    }

    .card-details {
      color: var(--green-800, #1a7a4c);
      font-size: 14px;
    }

  </style>

  <div class="cpo-section-form">
    <h2 class="cpo-section-title">{{ mode == 'add' ? 'Create Customer' : 'Edit Customer' }}</h2>
    <div style="margin: 0 20px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px 20px;">

      <div style="grid-column: span 1;">
        <app-textbox 
          [label]="'First Name'"
          [required]="true"
          [showRequired]="true"
          [(ngModel)]="this.boundCustomer.firstName"
          (onChanged)="checkCustomerValid()"
        ></app-textbox>
      </div>
      <div style="grid-column: span 1;">
        <app-textbox 
          [label]="'Last Name'"
          [required]="true"
          [showRequired]="true"
          [(ngModel)]="this.boundCustomer.lastName"
          (onChanged)="checkCustomerValid()"
        ></app-textbox>
      </div>

      <div style="grid-column: span 1;">
        <app-textbox 
          [label]="'Email Address'"
          [required]="true"
          [showRequired]="true"
          [type]="inputTextModes.Email"
          [(ngModel)]="this.boundCustomer.emailAddress"
        ></app-textbox>
      </div>
      <div style="grid-column: span 1;">
        <app-textbox
          [label]="'Phone # (optional)'"
          [type]="inputTextModes.Phone"
          [(ngModel)]="this.boundCustomer.phone"
          (onChanged)="checkCustomerValid()"
        ></app-textbox>
      </div>

      <div style="grid-column: span 1; display: flex; justify-content: center;">
        <input
          type="button"
          value="Cancel"
          class="cancel"
          (click)="btnCancel_click()"
          (keydown.escape)="btnCancel_click()"
        />
      </div>
      <div style="grid-column: span 1; display: flex; justify-content: center;">
        <input *ngIf="{ disabled: !customerValid || !customerChanged || updatingCustomer } as vars"
          type="button" [value]="mode == 'add' ? ( updatingCustomer ? 'Saving...' : 'Save' ) : ( updatingCustomer ? 'Updating...' : 'Update' )" class="primary" 
          [disabled]="vars.disabled" 
          (click)="vars.disabled ? null : saveCustomer()" 
          (keydown.enter)="vars.disabled ? null : saveCustomer()"
        />
      </div>

      @if (mode == 'edit') {
        <div style="grid-column: span 1;">
          @if (this.paymentMethods.length) {
            <h3 class="cpo-section-title">Payment Methods</h3>
            <div class="payment-methods-grid">
              @for (item of paymentMethods; track item.id) {
                <div class="payment-method-row">
                  <div class="card-type">{{ item.cardType }}</div>
                  <div class="card-details">****{{ item.cardLast4 }}</div>
                  <div class="card-details">@if (item.cardExpMonth) { {{ item.cardExpMonth }}/{{ item.cardExpYear }} }</div>
                  <app-icon
                    [style]="'cursor: pointer; width: fit-content;'"
                    [title]="'Delete ' + item.cardType + ' ending in ' + item.cardLast4"
                    [color]="'var(--archive-red)'"
                    (click)="deletePaymentMethod(item.id)"
                    type="Trash">
                  </app-icon>
                </div>
              }
            </div>
          }
        </div>
        <div style="grid-column: span 1; display: flex; flex-direction: column;">
          <div style="display: flex; align-items: start; gap: 40px;">
            <h3 class="cpo-section-title">Add Payment Method <i>(optional)</i></h3>
            <app-radio-group style="margin:auto;" [options]="paymentTypeOptions" [(ngModel)]="selectedPaymentType"></app-radio-group>
          </div>

          @if (selectedPaymentType == ProcessorType.Card) {
            <app-tokenize-form
              [merchantId]="merchantId"
              [customerId]="boundCustomer?.id"
              [formName]="'TerminalForm'"
              [paymentType]="selectedPaymentType"
              (onTokenized)="handleTokenized($event)"
              (onCancelled)="selectedPaymentType = null;"
            />
          } @if (selectedPaymentType == ProcessorType.ACH) {
            <app-tokenize-form
              [merchantId]="merchantId"
              [customerId]="boundCustomer?.id"
              [formName]="'TerminalForm'"
              [paymentType]="selectedPaymentType"
              (onValidationChange)="handleTokenizeFormValidationChanged($event)"
              (onTokenized)="handleTokenized($event)"
              (onCancelled)="selectedPaymentType = null;"
            />
          }
        </div>
      }
    </div>
  </div>


</app-access-manager>